export default __webpack_public_path__ + "static/media/xshort.c40a5154.svg";